import { Popover } from '@base-ui/react/popover'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface PopoverPositionerProps extends PartProps<Popover.Positioner.Props> {
  className?: string
}

function PopoverPositioner({ className, children, sideOffset = 4, ...props }: PopoverPositionerProps) {
  return (
    <Popover.Positioner className={twMerge('z-50', className)} sideOffset={sideOffset} {...props}>
      {children}
    </Popover.Positioner>
  )
}

export { PopoverPositioner }
